export const SITE_URL = "https://kathmandunational.edu.np";

// Resolves a site path against SITE_URL. Spaces and similar characters are
// encoded, already-encoded paths are left as they are, and absolute URLs pass through.
export const getPageUrl = (path: string = "") => new URL(path, SITE_URL).href;
